<template>
  <div class="columns is-multiline">
    <div class="column is-full-mobile is-6">
      <window height="100%" title="Basics">
        <p class="content">
          <b>Selected:</b> {{ selected }}
        </p>
        <b-field label="Find a JS framework">
          <b-autocomplete rounded v-model="name" :data="filteredDataArray"
          placeholder="e.g. jQuery" icon="magnify" @select="option => selected = option">
            <template slot="empty">No results found</template>
          </b-autocomplete>
        </b-field>
      </window>
    </div>
    <div class="column is-full-mobile is-6">
      <window title="Options">
        <div class="">
          <b-switch v-model="openOnFocus">
            Open dropdown on focus
          </b-switch>
          <b-switch v-model="keepFirst">
            Keep-first
            <small>(will always have first option pre-selected)</small>
          </b-switch>
        </div>
        <p class="content">
          <b>Selected:</b> {{ selected2 }}
        </p>
        <b-field label="Find a name">
          <b-autocomplete v-model="name2" placeholder="e.g. Anne"
          :keep-first="keepFirst" :open-on-focus="true" :data="filteredDataArray"
          field="user.first_name" @select="option => selected2 = option">
          </b-autocomplete>
        </b-field>
      </window>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [
        'Angular',
        'Angular 2',
        'Aurelia',
        'Backbone',
        'Ember',
        'jQuery',
        'Meteor',
        'Node.js',
        'Polymer',
        'React',
        'RxJS',
        'Vue.js',
      ],
      name: '',
      name2: '',
      selected: null,
      selected2: null,
      keepFirst: false,
      openOnFocus: false,
    };
  },
  computed: {
    filteredDataArray() {
      return this.data.filter(option => (
        option
          .toString()
          .toLowerCase()
          .indexOf(this.name.toLowerCase()) >= 0
      ));
    },
  },
};
</script>
